import { textactive } from "@/_core/_helpers/_parametric_tools";
import { min } from "d3";

export const D3ChartAnimation = function(_parentElement, _childElement) {
  this.parentElement = _parentElement;
  this.childElement = _childElement;
};

D3ChartAnimation.prototype.barsEnter = function(
  enter,
  svg,
  name,
  barWidth = 0.7,
  color = textactive,
  fillColor = textactive,
  xField = "date",
  yField = "value",
  multipleColor = false,
  toZero = true,
  heightAux = 2,
  lineWidth = 1,
  addId = false,
  idField = "id",
  multipleHeight = false,
  lowerField = "",
  offset = 0,
  xIsDate = false,
  bandWidthAux = 0
) {
  let bandWidth;
  if (xIsDate === false) {
    bandWidth = svg.x.bandwidth();
  } else {
    bandWidth = bandWidthAux;
  }
  const candleWidth = Math.floor(min([bandWidth * barWidth, 1000000]) / 2) * 2 + 1; // give space between bars
  const delta = Math.round((bandWidth - candleWidth) / 2); // space given
  offset = offset === 0 ? 0 : offset * bandWidth - delta;

  return enter
    .append("rect")
    .attr("class", "bars" + name)
    .style("fill", function(d, i) {
      return multipleColor ? fillColor[i] : fillColor;
    })
    .style("stroke", function(d, i) {
      return multipleColor ? color[i] : color;
    })
    .style("stroke-width", lineWidth)
    .attr("x", function(d) {
      return svg.x(d[xField]) + delta + offset;
    })
    .attr("y", function(d) {
      return toZero === true
        ? Math.min(svg.y(0), svg.y(d[yField]))
        : svg.y(d[yField]) - (multipleHeight ? 0 : heightAux / 2);
    })
    .attr("class", function(d, i) {
      return "bar" + name + "" + (addId ? d[idField] : i);
    })
    .attr("height", function(d) {
      return Math.max(
        0.00001,
        toZero === true
          ? Math.abs(svg.y(0) - svg.y(d[yField]))
          : multipleHeight
          ? svg.y(d[lowerField]) - svg.y(d[yField])
          : heightAux
      );
    })
    .attr("width", candleWidth)
    .style("opacity", function(d) {
      return +isFinite(d[yField]);
    })
    .style("shape-rendering", "crispEdges");
};
